import { ReactComponent as Sleep } from "@icons/sleep.svg";
import { TrackerProgressCard } from "../../../components/Trackers/TrackerProgressCard";
import { TrackerThresholdPercentages } from "core/state/Trackers/TrackerThresholdPercentages";
import { TrackerType } from "core/state/Trackers/TrackerType";
import { useTrackerContext } from "core/state/TrackerContext/TrackerContext";
import { useTranslation } from "react-i18next";

export const SleepTrackerProgressCard = () => {
  const { t } = useTranslation();
  const { getCurrentTrackerValue, getGoal } = useTrackerContext();

  const goal = getGoal(TrackerType.Sleep);
  const current = getCurrentTrackerValue(TrackerType.Sleep);
  const percent = current.percentageOf(goal, 0);

  function getProgressMessage(percentage: number): string {
    switch (true) {
      case percentage >= 100:
        return t(`wellbeing.trackers.progress.complete`);
      case percentage > TrackerThresholdPercentages.High:
        return t("wellbeing.trackers.sleep.progress.high", { goal, current, percent });
      case percentage >= TrackerThresholdPercentages.Medium:
        return t("wellbeing.trackers.sleep.progress.medium", { goal });
      default:
        return t("wellbeing.trackers.sleep.progress.low", { goal });
    }
  }

  return (
    <TrackerProgressCard
      trackerType={TrackerType.Sleep}
      percentage={percent}
      heading={t("wellbeing.trackers.sleep.progress.heading")}
      goalHeading={t("wellbeing.trackers.sleep.goal.heading")}
      goalDescription={t("wellbeing.trackers.sleep.goal.description")}
      goalIncrement={1}
      goalUnit={t("wellbeing.trackers.sleep.goal.unit")}
      progressMessage={getProgressMessage(percent)}
      Icon={Sleep}
    />
  );
};
